/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';
import { ClientBase } from './client-base';
import { ConfigService } from '../../config/config.service';
import { AdditionalContentType, EventStatus, RequestStatus } from './client';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class DashboardClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns Dashboard data for current user (Paged) [Club League Broadcaster].
     * @param pageNumber Page number. Integer
     * @param pageSize Page size. Integer
     * @return Returns Fixture event details
     */
    get(pageNumber: number, pageSize: number): Observable<PagedListOfDashboardItemDto> {
        let url_ = this.baseUrl + "/api/Dashboard?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfDashboardItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfDashboardItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PagedListOfDashboardItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfDashboardItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListOfDashboardItemDto>(null as any);
    }
}

/** Common paged list */
export class PagedListOfDashboardItemDto implements IPagedListOfDashboardItemDto {
    /** Page data */
    data?: DashboardItemDto[] | undefined;
    pageSize!: number;
    pageNumber!: number;
    /** Total count of elements */
    totalCount!: number;

    constructor(data?: IPagedListOfDashboardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DashboardItemDto.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedListOfDashboardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfDashboardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Common paged list */
export interface IPagedListOfDashboardItemDto {
    /** Page data */
    data?: DashboardItemDto[] | undefined;
    pageSize: number;
    pageNumber: number;
    /** Total count of elements */
    totalCount: number;
}

/** Dashboard item class */
export class DashboardItemDto implements IDashboardItemDto {
    /** BPP/Training id */
    eventId!: string;
    /** BPP/Training Club Name */
    eventCompanyName?: string | undefined;
    /** Club/Broadcaster id which BPP/Training/Request belong */
    ownerCompanyId?: string | undefined;
    /** Club/Broadcaster name which BPP/Training/Request belong */
    ownerCompanyName?: string | undefined;
    /** Id of user that raise an event */
    userId?: string | undefined;
    /** Name of user that raise an event */
    userName?: string | undefined;
    /** Company Id of user that raise an event */
    userCompanyId?: string | undefined;
    /** Company name of user that raise an event */
    userCompanyName?: string | undefined;
    /** Owner user roles */
    userRoles?: string[] | undefined;
    /** Status of dashboard event */
    dashboardItemStatus!: DashboardItemStatus;
    /** Type of dashboard event (BPP/Training Event/Request) */
    dashboardItemType!: DashboardItemType;
    /** Rize dashboard event time */
    updatedOn!: moment.Moment;
    /** BPP/Training arrival time */
    arrival!: moment.Moment;
    /** BPP/Training start time */
    start!: moment.Moment;
    /** BPP/Training location */
    location?: string | undefined;
    /** Selected Languages for BPP */
    languages?: string[] | undefined;
    /** Players/Managers for BPP */
    attendees?: AttendeeDto[] | undefined;
    /** Match information for BPP */
    matchData?: MatchDataDto | undefined;
    /** Cound of requests for BPP/training */
    totalRequests!: number;
    /** League note for BPP/training */
    leagueNote?: string | undefined;
    /** Flag that event was already approved previously */
    wasApproved!: boolean;
    /** Fixture event type */
    fixtureEventType!: FixtureEventType;
    /** Element id */
    elementId?: string | undefined;
    /** Interview */
    interviewee?: string | undefined;
    /** Interview type */
    interviewTypeName?: string | undefined;
    /** Broadcaster deadline */
    broadcasterDeadline?: string | undefined;
    /** Broadcaster deadline */
    isNonLiveFixtureEvent!: boolean;
    requests?: RequestDto[] | undefined;
    eventStatus?: EventStatus;
    isOverDeadline:boolean;
    updatedAfterApprovalOnUtc?:moment.Moment;
    updatedAfterApprovalUserName?:string | undefined;
    updatedAfterApprovalUserCompany?:string | undefined;
    additionalContentType?: AdditionalContentType;

    constructor(data?: IDashboardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventCompanyName = _data["eventCompanyName"];
            this.ownerCompanyId = _data["ownerCompanyId"];
            this.ownerCompanyName = _data["ownerCompanyName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userCompanyId = _data["userCompanyId"];
            this.userCompanyName = _data["userCompanyName"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(item);
            }
            this.dashboardItemStatus = _data["dashboardItemStatus"];
            this.dashboardItemType = _data["dashboardItemType"];
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : <any>undefined;
            this.arrival = _data["arrival"] ? moment.parseZone(_data["arrival"].toString()) : <any>undefined;
            this.start = _data["start"] ? moment.parseZone(_data["start"].toString()) : <any>undefined;
            this.location = _data["location"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(item);
            }
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(AttendeeDto.fromJS(item));
            }
            this.matchData = _data["matchData"] ? MatchDataDto.fromJS(_data["matchData"]) : <any>undefined;
            this.totalRequests = _data["totalRequests"];
            this.leagueNote = _data["leagueNote"];
            this.wasApproved = _data["wasApproved"];
            this.fixtureEventType = _data["fixtureEventType"];
            this.elementId = _data["elementId"];
            this.interviewee = _data["interviewee"];
            this.interviewTypeName = _data["interviewTypeName"];
            this.broadcasterDeadline = _data["broadcasterDeadline"];
            this.isNonLiveFixtureEvent = _data["isNonLiveFixtureEvent"];
            this.eventStatus = _data["eventStatus"];
            this.isOverDeadline = _data["isOverDeadline"];
            this.updatedAfterApprovalOnUtc = _data["updatedAfterApprovalOnUtc"] ? moment.parseZone(_data["updatedAfterApprovalOnUtc"].toString()) : <any>undefined;
            this.updatedAfterApprovalUserName = _data["updatedAfterApprovalUserName"];
            this.updatedAfterApprovalUserCompany = _data["updatedAfterApprovalUserCompany"];
            this.additionalContentType = _data["additionalContentType"];
        }
    }

    static fromJS(data: any): DashboardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventCompanyName"] = this.eventCompanyName;
        data["ownerCompanyId"] = this.ownerCompanyId;
        data["ownerCompanyName"] = this.ownerCompanyName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userCompanyId"] = this.userCompanyId;
        data["userCompanyName"] = this.userCompanyName;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item);
        }
        data["dashboardItemStatus"] = this.dashboardItemStatus;
        data["dashboardItemType"] = this.dashboardItemType;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : <any>undefined;
        data["arrival"] = this.arrival ? this.arrival.toISOString(true) : <any>undefined;
        data["start"] = this.start ? this.start.toISOString(true) : <any>undefined;
        data["location"] = this.location;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item.toJSON());
        }
        data["matchData"] = this.matchData ? this.matchData.toJSON() : <any>undefined;
        data["totalRequests"] = this.totalRequests;
        data["leagueNote"] = this.leagueNote;
        data["wasApproved"] = this.wasApproved;
        data["fixtureEventType"] = this.fixtureEventType;
        data["elementId"] = this.elementId;
        data["interviewee"] = this.interviewee;
        data["interviewTypeName"] = this.interviewTypeName;
        data["broadcasterDeadline"] = this.broadcasterDeadline;
        data["isNonLiveFixtureEvent"] = this.isNonLiveFixtureEvent;
        data["eventStatus"] = this.eventStatus;
        data["isOverDeadline"] = this.isOverDeadline;
        data["updatedAfterApprovalOnUtc"] = this.updatedAfterApprovalOnUtc ? this.updatedAfterApprovalOnUtc.toISOString(true) : <any>undefined;
        data["updatedAfterApprovalUserName"] = this.updatedAfterApprovalUserName
        data["updatedAfterApprovalUserCompany"] = this.updatedAfterApprovalUserCompany
        data["additionalContentType"] = this.additionalContentType
        return data;
    }
}

/** Dashboard item class */
export interface IDashboardItemDto {
    /** BPP/Training id */
    eventId: string;
    /** BPP/Training Club Name */
    eventCompanyName?: string | undefined;
    /** Club/Broadcaster id which BPP/Training/Request belong */
    ownerCompanyId?: string | undefined;
    /** Club/Broadcaster name which BPP/Training/Request belong */
    ownerCompanyName?: string | undefined;
    /** Id of user that raise an event */
    userId?: string | undefined;
    /** Name of user that raise an event */
    userName?: string | undefined;
    /** Company Id of user that raise an event */
    userCompanyId?: string | undefined;
    /** Company name of user that raise an event */
    userCompanyName?: string | undefined;
    /** Owner user roles */
    userRoles?: string[] | undefined;
    /** Status of dashboard event */
    dashboardItemStatus: DashboardItemStatus;
    /** Type of dashboard event (BPP/Training Event/Request) */
    dashboardItemType: DashboardItemType;
    /** Rize dashboard event time */
    updatedOn: moment.Moment;
    /** BPP/Training arrival time */
    arrival: moment.Moment;
    /** BPP/Training start time */
    start: moment.Moment;
    /** BPP/Training location */
    location?: string | undefined;
    /** Selected Languages for BPP */
    languages?: string[] | undefined;
    /** Players/Managers for BPP */
    attendees?: AttendeeDto[] | undefined;
    /** Match information for BPP */
    matchData?: MatchDataDto | undefined;
    /** Cound of requests for BPP/training */
    totalRequests: number;
    /** League note for BPP/training */
    leagueNote?: string | undefined;
    /** Flag that event was already approved previously */
    wasApproved: boolean;
    /** Fixture event type */
    fixtureEventType: FixtureEventType;
    /** Element id */
    elementId?: string | undefined;
    /** Interview */
    interviewee?: string | undefined;
    /** Interview type */
    interviewTypeName?: string | undefined;
    /** Broadcaster deadline */
    broadcasterDeadline?: string | undefined;
    /** Broadcaster deadline */
    isNonLiveFixtureEvent: boolean;
    requests?: RequestDto[] | undefined;
    eventStatus?: EventStatus | undefined;
    isOverDeadline: boolean;
    updatedAfterApprovalOnUtc?:moment.Moment;
    updatedAfterApprovalUserName?:string | undefined;
    updatedAfterApprovalUserCompany?:string | undefined;
    additionalContentType?:AdditionalContentType
}

export enum DashboardItemStatus {
    Unknown = 0,
    Submitted = 1,
    Updated = 2,
    Approved = 3,
    Rejected = 4,
    NotSubmitted = 5,
    RequestWithdrawn = 6,
}

export enum DashboardItemType {
    Unknown = 0,
    TrainingEvent = 1,
    FixtureEvent = 2,
    TrainingRequest = 3,
    FixtureRequest = 4,
    Deadline = 5,
    Interview = 6,
    InterviewRequest = 7,
    InterviewEvent = 8,
    InterviewEventRequest = 9,
    AdditionalContent = 10,
	AdditionalContentRequest = 11
}

/** Player/Manager information */
export class AttendeeDto implements IAttendeeDto {
    /** Player/Manager */
    role?: string | undefined;
    /** Specification of PLayer/Manager (Goalkeeper/ Staff ect.) */
    kind?: string | undefined;
    /** PLayer/Manager Name */
    fullName?: string | undefined;
    /** Player Appearances count */
    appCount!: number;
    /** PLayer/Manager BPP count */
    bppCount!: number;
    bios?: string | undefined;

    constructor(data?: IAttendeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.kind = _data["kind"];
            this.fullName = _data["fullName"];
            this.appCount = _data["appCount"];
            this.bppCount = _data["bppCount"];
            this.bios = _data["bios"];
        }
    }

    static fromJS(data: any): AttendeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["kind"] = this.kind;
        data["fullName"] = this.fullName;
        data["appCount"] = this.appCount;
        data["bppCount"] = this.bppCount;
        data["bios"] = this.bios;
        return data;
    }
}

export class RequestDto implements IRequestDto {
    
    requestId?: string  | undefined;
    companyId?: string  | undefined;
    companyName?: string  | undefined;
    status?: RequestStatus  | undefined;
    isAwaitingInformation?: boolean | undefined;
    eventId?: string | undefined;

    constructor(data?: IAttendeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.status = _data["status"];
            this.isAwaitingInformation = _data["isAwaitingInformation"];
            this.eventId = _data["eventId"];
        }
    }

    static fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["status"] = this.status;
        data["isAwaitingInformation"] = this.isAwaitingInformation;
        data["eventId"] = this.eventId;
        return data;
    }
}

/** Player/Manager information */
export interface IAttendeeDto {
    /** Player/Manager */
    role?: string | undefined;
    /** Specification of PLayer/Manager (Goalkeeper/ Staff ect.) */
    kind?: string | undefined;
    /** PLayer/Manager Name */
    fullName?: string | undefined;
    /** Player Appearances count */
    appCount: number;
    /** PLayer/Manager BPP count */
    bppCount: number;
    bios?: string | undefined;
}

export interface IRequestDto {
    requestId?: string  | undefined;
    companyId?: string  | undefined;
    companyName?: string  | undefined;
    status?: RequestStatus  | undefined;
    isAwaitingInformation?: boolean | undefined;
    eventId?: string | undefined;
}

/** Match information */
export class MatchDataDto implements IMatchDataDto {
    /** Home team name */
    homeTeamName?: string | undefined;
    /** Home team official name */
    homeTeamOfficialName?: string | undefined;
    /** Home team id */
    homeTeamId!: number;
    /** Away team name */
    awayTeamName?: string | undefined;
    /** Away team official name */
    awayTeamOfficialName?: string | undefined;
    /** Away team id */
    awayTeamId!: number;
    /** Match id */
    matchId!: number;
    /** Match Round */
    matchRound!: number;

    constructor(data?: IMatchDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.homeTeamName = _data["homeTeamName"];
            this.homeTeamOfficialName = _data["homeTeamOfficialName"];
            this.homeTeamId = _data["homeTeamId"];
            this.awayTeamName = _data["awayTeamName"];
            this.awayTeamOfficialName = _data["awayTeamOfficialName"];
            this.awayTeamId = _data["awayTeamId"];
            this.matchId = _data["matchId"];
            this.matchRound = _data["matchRound"];
        }
    }

    static fromJS(data: any): MatchDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeTeamName"] = this.homeTeamName;
        data["homeTeamOfficialName"] = this.homeTeamOfficialName;
        data["homeTeamId"] = this.homeTeamId;
        data["awayTeamName"] = this.awayTeamName;
        data["awayTeamOfficialName"] = this.awayTeamOfficialName;
        data["awayTeamId"] = this.awayTeamId;
        data["matchId"] = this.matchId;
        data["matchRound"] = this.matchRound;
        return data;
    }
}

/** Match information */
export interface IMatchDataDto {
    /** Home team name */
    homeTeamName?: string | undefined;
    /** Home team official name */
    homeTeamOfficialName?: string | undefined;
    /** Home team id */
    homeTeamId: number;
    /** Away team name */
    awayTeamName?: string | undefined;
    /** Away team official name */
    awayTeamOfficialName?: string | undefined;
    /** Away team id */
    awayTeamId: number;
    /** Match id */
    matchId: number;
    /** Match Round */
    matchRound: number;
}

export enum FixtureEventType {
    Standard = 0,
    Double = 1,
    Extended = 3,
    DoubleExtended = 4,
    ExtendedBroadcasterExclusive = 5,
    ExtendedMasterclass = 6,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}